import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

import { withTracker, hitTypes } from 'helpers/tracking';
import Link from 'components/Link';
import DislikeHeartbreakIcon from 'components/icons/DislikeHeartbreak.com.svg';
import DislikeHeartbreakMinusIcon from 'components/icons/DislikeHeartbreakMinus.com.svg';
import { getDislikesUrl } from 'helpers/namedUrls';
import cn from './styles.local.less';

const translationKeys = {
  ADD: __('dislikes.addedNotification'),
  REMOVE: __('dislikes.removedNotification'),
};

class DislikeAdNotification extends PureComponent {
  static propTypes = {
    adTitle: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    tracker: PropTypes.object.isRequired,
  };

  handleLinkClick = () => {
    const { tracker } = this.props;

    tracker.track(hitTypes.DISLIKE_NOTIFICATION_OVERVIEW_LINK_CLICK);
  };

  render() {
    const { adTitle, type } = this.props;
    const translationText = translationKeys[type];
    const newEl = translationText.replace(/\{(\w+)\}/g, `<b>${adTitle}</b>`);

    return (
      <div className={cn.root}>
        {type === 'ADD' ? (
          <DislikeHeartbreakIcon className={cns(cn.icon, cn.heartBreakIcon)} />
        ) : (
          <DislikeHeartbreakMinusIcon
            className={cns(cn.icon, cn.heartBreakMinusIcon)}
          />
        )}
        <div className={cn.notificationText}>
          <span dangerouslySetInnerHTML={{ __html: newEl }} />
          {type === 'ADD' ? (
            <Link
              to={getDislikesUrl()}
              rel="nofollow"
              className={cn.link}
              onClick={this.handleLinkClick}
            >
              {__('dislikes.notification.goToDislikesLink')}
            </Link>
          ) : null}
        </div>
      </div>
    );
  }
}

export default withTracker(DislikeAdNotification);
